import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Optional, Output } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { TextAreaProps } from '@bl/components/dist/text-area/types';
import { BlFrontendBaseComponent } from './bl-frontend-base.component';

@Component({
  selector: 'bl-frontend-textarea',
  template: ``,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlFrontendTextAreaComponent
  extends BlFrontendBaseComponent<TextAreaProps>
  implements ControlValueAccessor
{
  @Input() id: string;
  @Input() value: TextAreaProps['value'] = '';
  @Input() placeholder: TextAreaProps['placeholder'] = '';
  @Input() text: TextAreaProps['text'] = '';
  @Input() maxLength: TextAreaProps['maxLength'] = 40;
  @Input() maxLengthText: TextAreaProps['maxLengthText'] = '';
  @Input() rows: TextAreaProps['rows'];
  @Input() disabled: TextAreaProps['disabled'];
  @Input() name: TextAreaProps['name'];
  @Input() resizeable: TextAreaProps['resizeable'];
  @Output() blurEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    protected override ref: ElementRef,
    @Optional() private ngControl: NgControl,
  ) {
    super(ref);
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  private onChange: (value: string) => void;
  private onTouched: () => void;

  writeValue(obj: string): void {
    this.updateProps({ value: obj });
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.updateProps({ disabled: isDisabled });
  }

  protected getComponentName(): string {
    return 'TextArea';
  }

  protected getProps(): TextAreaProps {
    const props: TextAreaProps = {
      id: this.id,
      value: this.value,
      maxLength: this.maxLength,
      maxLengthText: this.maxLengthText,
      rows: this.rows,
      disabled: this.disabled,
      placeholder: this.placeholder,
      text: this.text,
      name: this.name,
      resizeable: this.resizeable,
      onInput: (value: string) => {
        this.onChange?.(value);
        this.valueChange.emit(value);
      },
      onBlur: (e: string) => {
        this.blurEvent.emit(e);
        this.onTouched?.();
      },
    };

    return props;
  }
}
